import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { interval } from 'rxjs/observable/interval';
import { timer } from 'rxjs/observable/timer';
import { map, take, takeWhile } from 'rxjs/operators';

@Component({
  selector: 'app-countdown',
  templateUrl: './countdown.component.html',
  styleUrls: ['./countdown.component.scss']
})
export class CountdownComponent  {

  @Input() message = '';
  @Input() minutes: number;
  @Input() delay = 0;
  @Output() endCountDownEvent = new EventEmitter();

  public secondsToDday = '00';
  public minutesToDday = '00';
  public hoursToDday = '00';
  public renderCountdown = false;

  public startCountdown() {
    this.renderCountdown = true;
    timer(this.delay, 1000)
      .pipe(take(this.minutes * 60))
      .pipe(map(v => this.minutes * 60 - 1 - v))
      .pipe(takeWhile(x => x >= 0))
      .subscribe(countdown => {

        const hours = Math.floor((Math.floor(countdown / 60)) / 60);
        const minutes = Math.floor(countdown / 60);
        const seconds = countdown - minutes * 60;

        this.hoursToDday = ('0' + hours.toString()).slice(-2);
        this.secondsToDday = ('0' + seconds.toString()).slice(-2);
        this.minutesToDday = ('0' + minutes.toString()).slice(-2);

        if (seconds <= 0 && minutes <= 0) {
          this.endCountDown();
        }
      });
  }

  private endCountDown() {
    this.renderCountdown = false;
    this.endCountDownEvent.emit();
  }
}
